var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / 24 / icon_user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z",
    stroke: "#E30031",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1578 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 18C2.75 15.6528 4.65279 13.75 7 13.75H17C19.3472 13.75 21.25 15.6528 21.25 18V22.5C21.25 22.7761 21.0261 23 20.75 23H19.25C18.9739 23 18.75 22.7761 18.75 22.5V18C18.75 17.0335 17.9665 16.25 17 16.25H7C6.0335 16.25 5.25 17.0335 5.25 18V22.5C5.25 22.7761 5.02614 23 4.75 23H3.25C2.97386 23 2.75 22.7761 2.75 22.5V18Z",
    fill: "#E30031"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.6cf73a3d1729e9a15bd0facbb4dbbaac.svg";
export { ForwardRef as ReactComponent };